var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"chawgt-cta"},[(_vm.firstWidgetAgent)?_c('div',{staticClass:"agent-picture",style:(`background-image: url('${_vm.firstWidgetAgent.url}')`)}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }